import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminUsers_idVerify = z.any()
export type TagsPostAdminUsers_idVerify = z.infer<typeof tagsPostAdminUsers_idVerify>

export const paramsPostAdminUsers_idVerify = z.object({ "id": z.string() })
export type ParamsPostAdminUsers_idVerify = z.infer<typeof paramsPostAdminUsers_idVerify>

export const responsePostAdminUsers_idVerify = z.object({ "payload": z.object({ "message": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminUsers_idVerify = z.infer<typeof responsePostAdminUsers_idVerify>

interface IPostAdminUsers_idVerify extends BaseMethodType {
  tags: TagsPostAdminUsers_idVerify,
  params: ParamsPostAdminUsers_idVerify,
  response: ResponsePostAdminUsers_idVerify
}
export const URL = '/admin/users/:id/verify'
export const validation = {
  post: {
    tags: tagsPostAdminUsers_idVerify,
    params: paramsPostAdminUsers_idVerify,
    response: responsePostAdminUsers_idVerify
  }
}
export interface AdminUsers_idVerify extends BaseRouteType {
  post: IPostAdminUsers_idVerify
}